import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

let IconMicrophone = (props) => {
  props = Object.assign({viewBox: '0 0 510.771 510.771'}, props);
  return (
    <SvgIcon {...props}>
      <g><path d="m98.268 403.69 24.28 24.28 258.357-206.579c25.433-2.54 49.201-13.774 67.38-31.954 20.966-20.966 32.512-48.842 32.511-78.492-.001-29.648-11.547-57.522-32.511-78.485-43.279-43.279-113.699-43.279-156.977 0-18.184 18.183-29.419 41.957-31.956 67.397l-206.105 258.811 23.808 23.809-30.262 30.262c-10.846 10.847-16.819 25.268-16.819 40.606 0 31.665 25.761 57.426 57.426 57.426h291.231v-30h-291.231c-15.123 0-27.426-12.303-27.426-27.426 0-7.326 2.853-14.213 8.033-19.394zm89.799-66.519-44.173-44.173 81.503-102.345 64.832 64.831zm125.737-100.537-69.599-69.599 31.013-38.944 77.459 77.46zm-1.282-182.962c31.583-31.583 82.97-31.581 114.551 0 15.298 15.298 23.723 35.638 23.724 57.273 0 21.637-8.425 41.979-23.724 57.278-12.589 12.589-28.849 20.599-46.328 22.968l-91.192-91.192c2.37-17.477 10.38-33.737 22.969-46.327zm-187.436 262.944 39.406 39.406-39.712 31.753-31.375-31.375z"/></g>
    </SvgIcon>
  );
};

IconMicrophone.displayName = 'IconMicrophone';
IconMicrophone.muiName = 'SvgIcon';

export default IconMicrophone;



// WEBPACK FOOTER //
// ./src/components/Icons/IconMicrophone.js